





































import _ from 'lodash'
import Vue from 'vue'
import Component from 'vue-class-component'
import {get} from "@/modules/config";
import {Prop} from "vue-property-decorator";
import {AxiosError} from "axios";

@Component
export default class Login extends Vue {

    public $refs: Vue['$refs'] & {
        form: {
            validate(): boolean;
        };
    }

    @Prop({type: Boolean, default: false})
    public cancellable: boolean

    /**
     * Texto del botón cancelar
     */
    @Prop({type: String, default: 'Cancelar'})
    public cancelText: string

    public user = ''
    public password = ''
    public loading = false
    public error = ''

    /**
     * Reglas de validación para el formulario de inicio de sesión
     */
    public rules = {
        user: [
            (v: string) => !!v || 'El usuario no puede estar vacío',
        ],
        password: [
            (v: string) => !!v || 'La contraseña no puede estar vacía',
        ]
    }

    /**
     * Solicita a la aplicación un nuevo token
     */
    public async login () {
        if (!this.$refs.form.validate()) {
            return
        }

        this.error = ''
        this.loading = true

        const token = await this.$store.dispatch('login', {
            user: this.user,
            password: this.password
        })

        this.loading = false

        // Notifica al componente padre de que el login se ha realizado correctamente
        this.$emit('login', token)
    }

    /**
     * Al crear el componente carga en el campo "user" el nombre de usuario o email
     * del último login correcto realizado.
     */
    public created () {
        this.user = get('savedUser', '')
    }

    errorCaptured (error: AxiosError) {
        this.loading = false
        this.error = _.get(error,
            'response.data.error_description',
            _.get(error, 'response.data.message', error.message)
        )
    }
}
